import React from 'react';

const CrackingTheCodeComponent = () => {
  return (
    <div className="container-fluid min-vh-80 case-study-component p-0 mt-5">
      <div
        className="row g-0"
        style={{
          background: 'linear-gradient(357deg, rgba(47, 51, 122, 1) 0%, rgba(0, 0, 0, 1) 75%)',
        }}
      >
        {/* Left Side - Text */}
        <div
          className="col-md-12 d-flex flex-column justify-content-center text-white px-5"
          style={{
            paddingTop: '110px',
            paddingBottom: '100px',
          }}
        >
          <h1 className="display-4 fw-bold text-left aws-section">
            Cracking The Code: APAC CX Transformation Success Unveiled!
          </h1>
        </div>

       
      </div>
    </div>
  );
};

export default CrackingTheCodeComponent;
